// 操作用户token
// import store from '@/store'
// 定义token存储的key
const TokenKey = 'Tokens'

// 获取token
export function getToken () {
  let token = sessionStorage.getItem(TokenKey)
  if (token) {
    return token
  } else {
    return null
  }
  // token = localStorage.getItem(TokenKey)
  // if (token) {
  //   sessionStorage.setItem(TokenKey, token)
  // }
  // return token
}
// 设置token
export function setToken (token) {
  sessionStorage.setItem(TokenKey, token)
  // if (store.state.user && store.state.user.autoLogin) {
  //   localStorage.setItem(TokenKey, token)
  // }
  return true
}
// 删除token
export function removeToken () {
  sessionStorage.removeItem(TokenKey)
  // localStorage.removeItem(TokenKey)
  return true
}



// WEBPACK FOOTER //
// ./src/utils/auth.js